import { render, staticRenderFns } from "./applicant-compare-data.vue?vue&type=template&id=f3b409a0"
import script from "./applicant-compare-data.vue?vue&type=script&lang=js"
export * from "./applicant-compare-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports